<template>
<div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ getTitre }}
              </h1>
              <app-breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <div class="level-right">
          <div class="is-pulled-right buttons boutonAction">
              <a class="button" @click="$router.go(-1)">
                {{$t('general.button.cancel')}}
              </a>
              <a class="button is-addOrEdit" @click="sauvegardeOperationDiverse()">
                {{$t('general.button.sauvegarder')}}
              </a>
          </div>
        </div>
      </div>
    </div>
    <br>
    <error-msg-component :messages="messages"
                        :error="error"
                        :messagesChampsVide="messagesChampsVide"
                        :champsVide="champsVide"
                        :title="'general.problemOccurred'"
                        :withEmplyFields="true"
                        @close="error = $event"/>
    <div class="card">
      <header class="header-card">
        <p>{{$t('addOperationDiverse.informationsMouvement.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <p class="has-text-danger mgl-10px" v-if="isLettre">
            {{ $t('addOperationDiverse.messages.errorMessage')}}
          </p>
          <b-field :label="$t('addOperationDiverse.informationsMouvement.tiers')"
              class="column is-12 obligatoire">
            <b-autocomplete icon="magnify" v-model="infoTiers.tiers"
                      group-field="type"
                      group-options="items"
                      field="nomCommercialAvecVille"
                      :placeholder="$i18n.t('addOperationDiverse.informationsMouvement.search')"
                      :data="infoTiers.dataAutoComplete"
                      @input="getTiersASync()"
                      @select="item => selectTiers(item)"
                      :disabled="isLettre">
            </b-autocomplete>
          </b-field>
          <b-field :label="$t('addOperationDiverse.informationsMouvement.dateMouvement')"
            class="column is-3 obligatoire">
            <b-datepicker show-week-number
              icon="calendar-today"
              nearby-selectable-month-days
              v-model="operationDiverse.mouvementOd.dateMouvement"
              :editable="true"
              :disabled="isLettre">
            </b-datepicker>
          </b-field>
          <b-field :label="$t('addOperationDiverse.libelle')"
            class="column is-5 obligatoire">
            <b-input v-model="operationDiverse.mouvementOd.libelle" :disabled="isLettre"></b-input>
          </b-field>
          <b-field :label="$t('addOperationDiverse.informationsMouvement.montant')"
            class="column is-2 obligatoire">
            <input-currency isNumber="true"
                          v-model="montantDebitOrCredit"
                          @input="getMontantDebitOrCredit"
                          :disabled="isLettre">
            </input-currency>
          </b-field>
          <b-field :label="$t('addOperationDiverse.informationsMouvement.sens')"
            class="column is-é">
            <b-select v-model="typeSens" expanded :disabled="isLettre">
              <option v-for="sens in listeSens"
                      :key="sens.code"
                      :value="sens.code">
                {{ $t(sens.libelle) }}
              </option>
            </b-select>
          </b-field>
          <b-field :label="$t('addOperationDiverse.journal')"
            class="column obligatoire is-3">
            <b-input v-model="operationDiverse.journal" :disabled="isLettre"></b-input>
          </b-field>
          <b-field :label="$t('addOperationDiverse.reference')"
            class="column is-3">
            <b-input v-model="operationDiverse.reference" :disabled="isLettre"></b-input>
          </b-field>
          <b-field class="column is-5 mgt-30px">
            <b-checkbox v-model="operationDiverse.exportOdComptabilite" :disabled="isLettre">
                {{ $t('addOperationDiverse.exportOdComptabilite') }}
            </b-checkbox>
          </b-field>
        </div>
      </div>
    </div>
    <div class="card mgt-20px">
      <header class="header-card">
        <p>{{$t('addOperationDiverse.informationsLigne.title')}}</p>
      </header>
      <div class="card-content">
        <div class="columns is-multiline">
          <b-table :data="operationDiverse.lignesOd"
                  :bordered="true"
                  :striped="true"
                  class="column is-12">
            <b-table-column field="compte"
                            :label="$t('addOperationDiverse.compteComptable')"
                            v-slot="props">
              <b-input v-model="props.row.compte"></b-input>
            </b-table-column>
            <b-table-column field="compteAuxiliaire"
                            :label="$t('addOperationDiverse.informationsLigne.compteAuxiliaire')"
                            v-slot="props">
              <b-input v-model="props.row.compteAuxiliaire"></b-input>
            </b-table-column>
            <b-table-column field="libelle"
                            :label="$t('addOperationDiverse.libelle')"
                            v-slot="props">
              <b-input v-model="props.row.libelle"></b-input>
            </b-table-column>
            <b-table-column field="reference"
                            :label="$t('addOperationDiverse.reference')"
                            v-slot="props">
              <b-input v-model="props.row.reference"></b-input>
            </b-table-column>
            <b-table-column field="debit"
                            :label="$t('addOperationDiverse.debit')"
                            v-slot="props">
              <input-currency v-model="props.row.debit"
                      isNumber="true">
              </input-currency>
            </b-table-column>
            <b-table-column field="credit"
                            :label="$t('addOperationDiverse.credit')"
                            v-slot="props">
              <input-currency v-model="props.row.credit"
                      isNumber="true">
              </input-currency>
            </b-table-column>
            <b-table-column field="credit" cell-class="has-text-centered vertical-alignment"
                            :label="$t('addOperationDiverse.informationsLigne.ligneCompteTva')"
                            v-slot="props">
                <div class="centered-checkox">
                  <b-checkbox v-model="props.row.ligneCompteTva"/>
                </div>
            </b-table-column>
            <b-table-column field="delete"
                            v-slot="props">
              <a @click="deleteLigne(props.index)" class="has-text-centered">
                <b-icon
                  class="mgt-5px"
                  icon="delete-forever"
                  type="is-danger">
                </b-icon>
              </a>
            </b-table-column>
            <template #empty>
              {{ $t('addOperationDiverse.aucuneLigne')}}
            </template>
            <template #footer>
              <td colspan="4">
                <button
                  class="button is-primary"
                  @click="addNewLigne()">
                  {{ $t('addOperationDiverse.actions.addNewLine') }}
                </button>
              </td>
              <td class="right has-text-weight-bold">
                <span :class="isError ? 'has-text-danger' : ''">
                    {{ totalDebit  | formatDevise }}
                  </span>
              </td>
              <td class="right has-text-weight-bold">
                <span :class="isError ? 'has-text-danger' : ''">
                    {{ totalCredit | formatDevise }}
                  </span>
              </td>
              <td colspan="2"></td>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import errorMsgComponent from '@/components/general/errorMsgComponent';
import breadcrumb from '@/components/general/breadcrumb';
import { get, create, update } from '@/api/compta/operationDiverse/index';
import formatIsoDate from '@/services/general/formatIsoDate';
import genererOperationDiverse from '@/services/compta/operationDiverse/genererOperationDiverse';
import messageErreur from '@/services/general/messageErreur';
import debounce from 'lodash/debounce';
import { getAll } from '@/api/tiers';
import {
  TIERS_SOUS_TYPE_AUCUN,
  TIERS_SOUS_TYPE_BAILLEUR_PRO,
  TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
  TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
  TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
} from '@/configuration/tiers/tiersConf';
import { createNamespacedHelpers } from 'vuex';
import inputCurrency from '@/components/general/inputCurrency';
import genererLigneOd from '@/services/compta/operationDiverse/genererLigneOd';
import cloneDeep from 'lodash/cloneDeep';
import { SENS_DEBIT_CREDIT, CREDIT, DEBIT } from '@/configuration/compta/odConfig';
import translate from '@/services/compta/operationDiverse/validation/champsOdTranslator';
import validation from '@/services/compta/operationDiverse/validation/validation';
import validationGeneral from '@/services/validation/validation';
import decimalsFormater from '@/services/general/decimalsFormater';
import messageSucces from '@/services/general/messageSucces';
import { NON_LETTRE } from '@/configuration/lettrageConf';
import adressFullStringGetter from '@/services/general/adressFullStringGetter';
import miseEnFormeAddresseTiers from '@/services/compta/operationDiverse/miseEnFormeAddresseTiers';
import { REMOVE_OD } from '@/store/modules/compta/operationDiverse-mutation-type';

const Societe = createNamespacedHelpers('societe');
const OperationDiverse = createNamespacedHelpers('operationDiverse');

export default {
  data() {
    return {
      infoTiers: {
        tiers: '',
        tiersSelected: null,
        dataAutoComplete: [],
        compteComptable: null,
        adressePostale: null,
      },
      messages: [],
      champsVide: [],
      messagesChampsVide: [],
      error: false,
      operationDiverse: genererOperationDiverse(),
      montantDebitOrCredit: 0,
      typeSens: DEBIT,
      constantes: {
        CREDIT,
        DEBIT,
      },
      listeSens: SENS_DEBIT_CREDIT,
    };
  },
  components: {
    errorMsgComponent,
    appBreadcrumb: breadcrumb,
    inputCurrency,
  },
  watch: {
    typeSens() {
      this.getMontantDebitOrCredit();
    },
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societe: 'societeActive',
    }),
    ...OperationDiverse.mapGetters({
      operationDiverseStored: 'operationDiverse',
    }),
    getTitre() {
      if (this.$route.params.id) return this.$t('addOperationDiverse.titleEdit');
      return this.$t('addOperationDiverse.titleAdd');
    },
    breadcrumb() {
      const output = [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeOperationDiverse.title'), route: { name: 'l.comptabilite.operation_diverse' }, isActive: false },
        { title: this.getTitre, isActive: true },
      ];
      return output;
    },
    totalCredit() {
      let total = 0;
      total += this.operationDiverse.mouvementOd.credit;
      total += this.operationDiverse.lignesOd
        .map(f => f.credit)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    totalDebit() {
      let total = 0;
      total += this.operationDiverse.mouvementOd.debit;
      total += this.operationDiverse.lignesOd
        .map(f => f.debit)
        .reduce((a, b) => a + b, 0);
      return total;
    },
    isError() {
      return this.totalCredit !== this.totalDebit;
    },
    isLettre() {
      if (this.$route.params.id) {
        return this.operationDiverse.mouvementOd.etatLettrage !== NON_LETTRE;
      }
      return false;
    },
  },
  methods: {
    ...OperationDiverse.mapMutations({
      removeOperationDiverse: REMOVE_OD,
    }),
    getTiersASync: debounce(async function loadData() {
      if (this.infoTiers.tiersSelected
        && this.infoTiers.tiersSelected.nomCommercialAvecVille === this.infoTiers.tiers) {
        return;
      }
      const loadingComponent = this.$buefy.loading.open();
      try {
        if (this.infoTiers.tiers.length > 0) {
          const dataClient = await getAll({
            query: {
              archive: false,
              auto: this.infoTiers.tiers,
              sousType: [
                TIERS_SOUS_TYPE_AUCUN,
                TIERS_SOUS_TYPE_BAILLEUR_PRO,
                TIERS_SOUS_TYPE_BAILLEUR_CONCESSION,
                TIERS_SOUS_TYPE_BAILLEUR_ADMINISTRATION_ET_ASSIMILEE,
                TIERS_SOUS_TYPE_BAILLEUR_PRIVE,
              ],
              societeId: this.societeActiveId,
            },
          });
          this.modificationAutoComplete(dataClient.data.result);
        }
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw (e);
      }
      this.infoTiers.tiersSelected = null;
    }, 500),
    modificationAutoComplete(dataClient) {
      this.infoTiers.dataAutoComplete = [];
      dataClient.items.forEach((tiers) => {
        tiers.nomCommercialAvecVille = [
          tiers.code, tiers.nomCommercial,
          adressFullStringGetter(tiers.adressePostale, false),
          tiers.compteComptable,
        ].filter(e => !!e).join(' - ');
      });
      if (dataClient.items.some(tier => tier.sousTypes.includes(TIERS_SOUS_TYPE_AUCUN))) {
        this.infoTiers.dataAutoComplete.push({
          type: this.$t('addOperationDiverse.typeTiers.client'),
          items: cloneDeep(dataClient.items.filter(tier => {
            return tier.sousTypes.includes(TIERS_SOUS_TYPE_AUCUN);
          })),
        });
      }
      if (dataClient.items.some(tier => !tier.sousTypes.includes(TIERS_SOUS_TYPE_AUCUN))) {
        this.infoTiers.dataAutoComplete.push({
          type: this.$t('addOperationDiverse.typeTiers.bailleur'),
          items: cloneDeep(dataClient.items.filter(tier => {
            return !tier.sousTypes.includes(TIERS_SOUS_TYPE_AUCUN);
          })),
        });
      }
    },
    selectTiers(tiers) {
      if (tiers === null) return;
      this.infoTiers.tiersSelected = tiers;
      this.infoTiers.compteComptable = tiers.compteComptable;
      this.infoTiers.adressePostale = tiers.adressePostale.adresse1;
      this.operationDiverse.mouvementOd.tiersId = tiers.id;
    },
    addNewLigne() {
      this.operationDiverse.lignesOd.push(cloneDeep(genererLigneOd()));
      this.operationDiverse.lignesOd.forEach((ligneOd) => {
        ligneOd.reference = this.operationDiverse.reference;
        ligneOd.libelle = this.operationDiverse.mouvementOd.libelle;
      });
    },
    deleteLigne(index) {
      this.operationDiverse.lignesOd.splice(index, 1);
    },
    getMontantDebitOrCredit() {
      if (this.typeSens === this.constantes.DEBIT) {
        this.operationDiverse.mouvementOd.debit = Number(decimalsFormater(
          this.montantDebitOrCredit,
        ));
        this.operationDiverse.mouvementOd.credit = 0;
      } else {
        this.operationDiverse.mouvementOd.debit = 0;
        this.operationDiverse.mouvementOd.credit = Number(decimalsFormater(
          this.montantDebitOrCredit,
        ));
      }
    },
    async sauvegardeOperationDiverse() {
      this.error = false;
      this.champsVide = [];
      this.messagesChampsVide = [];
      this.messages = [];
      const loadingComponent = this.$buefy.loading.open();
      try {
        const operationDiverse = cloneDeep(this.operationDiverse);
        operationDiverse.mouvementOd.dateMouvement = formatIsoDate(
          operationDiverse.mouvementOd.dateMouvement,
        );
        let od = {};
        if (this.$route.params.id) {
          od = (await update(operationDiverse)).data.result;
          messageSucces(this.$i18n.t('addOperationDiverse.messages.successModification'));
        } else {
          od = (await create(operationDiverse)).data.result;
          messageSucces(this.$i18n.t('addOperationDiverse.messages.successCreation'));
        }
        loadingComponent.close();
        this.$router.push({
          name: 'c.comptabilite.operation_diverse',
          params: { id: od.id },
        });
      } catch (e) {
        loadingComponent.close();
        if (e.response) {
          validation(e.response, this.messages);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.error = true;
        } else {
          messageErreur(this.$i18n);
        }
        throw (e);
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.$route.params.id) {
        this.operationDiverse = (await get(this.$route.params.id)).data.result;
        this.operationDiverse.mouvementOd.dateMouvement = new Date(
          this.operationDiverse.mouvementOd.dateMouvement,
        );
        this.typeSens = this.operationDiverse.mouvementOd.debit > 0 ? DEBIT : CREDIT;
        this.montantDebitOrCredit = this.operationDiverse.mouvementOd.debit > 0
          ? this.operationDiverse.mouvementOd.debit : this.operationDiverse.mouvementOd.credit;
        this.infoTiers.tiersSelected = this.operationDiverse.mouvementOd.tiers;
        this.infoTiers.tiers = miseEnFormeAddresseTiers(this.operationDiverse.mouvementOd);
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.operationDiverse.reference }));
      } else {
        if (this.operationDiverseStored) {
          this.operationDiverse = cloneDeep(this.operationDiverseStored);
          this.infoTiers.tiersSelected = this.operationDiverse.mouvementOd.tiers;
          this.infoTiers.tiers = miseEnFormeAddresseTiers(this.operationDiverse.mouvementOd);
          this.removeOperationDiverse();
        }
        this.setInformationPage(this.$t('pageCompta.operationDiverse.creation'));
        this.operationDiverse.exportOdComptabilite = this.societe.exportOdComptabiliteDefaut;
        this.operationDiverse.journal = this.societe.journalOd;
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
